import { Injectable, OnDestroy } from '@angular/core'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { TranslocoService } from '@jsverse/transloco'
import { Subject } from 'rxjs'
import { startWith, switchMap, takeUntil } from 'rxjs/operators'

@Injectable()
export class TranslocoPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private destroy$ = new Subject<void>()

  constructor(private translocoService: TranslocoService) {
    super()
    this.translocoService.langChanges$.pipe(
      startWith(this.translocoService.getActiveLang()),
      switchMap(lang => this.translocoService.selectTranslation(lang)),
      takeUntil(this.destroy$),
    ).subscribe(() => this._updateLabels())
  }

  private t(key: string, fallback: string): string {
    const result = this.translocoService.translate(key)
    return result === key ? fallback : result
  }

  private _updateLabels() {
    this.itemsPerPageLabel = this.t('paginator.items_per_page', 'Items per page:')
    this.nextPageLabel     = this.t('paginator.next_page', 'Next page')
    this.previousPageLabel = this.t('paginator.previous_page', 'Previous page')
    this.firstPageLabel    = this.t('paginator.first_page', 'First page')
    this.lastPageLabel     = this.t('paginator.last_page', 'Last page')
    this.changes.next()
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const startIndex = page * pageSize
    const endIndex   = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize

    if (length === 0 || pageSize === 0) {
      return this.translocoService.translate('paginator.range_zero', { length })
    }
    return this.translocoService.translate('paginator.range', {
      start: startIndex + 1,
      end: endIndex,
      length,
    })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
